export class GetidConfig {
  constructor({
    flow,
  }) {
    Object.assign(this, {
      flowName: flow,
    });
  }
}
